module.exports = __webpack_public_path__ + "static/media/Impreza-GV-WRX-STi.477222fc.webp";